import { LinearProgress, withStyles } from '@material-ui/core'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import withErrorCatcher from '../../../components/Common/withErrorCatcher'
import { useTranslation } from 'react-i18next'
import { styled } from '@material-ui/styles'

const styles = theme => ({
    container: {
        position: 'relative',
        zIndex: 1,
        marginTop: '10vh',
        marginRight: 'auto',
        marginLeft: "auto",
        display: 'flex',
        flexDirection: 'column',
        width: 'fit-content',
        alignItems: 'center',
    },
    title: {
        color: "#18181B",
        fontFamily: "Rubik",
        fontSize: 24,
        fontStyle: "normal",
        fontWeight: 600,
        lineHeight: "32px"
    },
    subtitle: {
        color: "#6B6F7A",
        fontFamily: "Rubik",
        fontSize: 14,
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "20px"
    },
    btns: {
        marginTop: '3vh',
        display: 'flex',
        marginBottom: '6vh',
        alignItems: 'center'
    },
    btn: {
        marginTop: '4vh',
        cursor: 'pointer',
        display: "flex",
        background: '#6366F1',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: "space-between",
        padding: '6px 30px',
        borderRadius: 6,
        border: '1px solid transparent',
        height: 20,
        width: 'fit-content'
    },
    btnWhite: {
        border: '1px solid #B7B8BD33',
        cursor: 'pointer',
        display: "flex",
        background: '#fff',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: "space-between",
        padding: '6px 30px',
        borderRadius: 6,
        height: 20,
        width: 'fit-content'
    },
    btnText: {
        color: "#fff",
        fontFamily: "Rubik",
        fontSize: 14,
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "20px"
    },
    btnTextWhite: {
        color: "#6B6F7A",
        fontFamily: "Rubik",
        fontSize: 14,
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "20px"
    },
    disabledBtn: {
        pointerEvents: 'none',
        background: '#B7B8BD'
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: "center",
        alignItems: "flex-start",
        borderRadius: 8,
    },
    label: {
        marginBottom: 8,
        marginTop: 24,
        marginRight: 'auto',
        marginLeft: 'auto',
        color: "#18181B",
        fontFamily: "Rubik",
        fontSize: 14,
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "20px"
    },
    input: {
        color: '#21212d',
        width: '-webkit-fill-available',
        resize: 'none',
        padding: 0,
        outline: 0,
        fontSize: 14,
        fontStyle: 'normal',
        fontWeight: 400,
        fontFamily: "Rubik",
        lineHeight: "16px",
        paddingLeft: 8,
        paddingRight: 8,
        backgroundColor: "transparent",
        borderRadius: 8,
        border: '1px solid #B7B8BD33',
        height: 32,
        fontFeatureSettings: "'clig' off, 'liga' off",
        "&::placeholder": {
            color: '#B7B8BD',
        },
    },
    progressPrimary: {
        background: "var(--bg-accent-alt-DEFAULT, rgba(129, 140, 248, 0.10))",
    },
    progressAccent: {
        backgroundColor: '#818CF8',
    },
    loader: {
        marginTop: '10vh',
    }
})



const _Step5 = (props) => {
    const { classes, onEnterSystem } = props
    const [t] = useTranslation("admin")

    useEffect(() => {
        onEnterSystem()
    }, [])

    return <div className={classes.container}>
        <img className={classes.loader} alt='ff' src={"/resources/signup_setup_complete.png"} />
        <div className={classes.title}>{t("Setup Completed!")}</div>
        <div className={classes.subtitle}>{t("Your system is ready. Let’s get started.")}</div>
        <div className={classes.content}>
            <div onClick={undefined} className={`${classes.btn}`}>
                <div className={classes.btnText}>{t("Enter the system")}</div>
            </div>
        </div>
    </div>
}

const mapStateToProps = (state, ownProps) => ({

})

const mapDispatchToProps = (dispatch) => ({ dispatch })


export const Step5 = compose(
    withStyles(styles, { withTheme: true }),   
    connect(mapStateToProps, mapDispatchToProps),
    withErrorCatcher("Failed loading user, Please Contact Tuqqi Support")
)(_Step5)